import LogoContainer from '@components/elements/LogoContainer'
import Section from '@components/elements/Section'
import Title from '@components/elements/Title'
import React from 'react'

const availableItems = [
  {
    title: 'React-Native',
    src: require('../../assets/logos/technologies/react-native.svg').default,
    sections: ['app', 'agency']
  },
  {
    title: 'Android',
    src: require('../../assets/logos/technologies/android.svg').default,
    sections: ['app', 'agency']
  },
  {
    title: 'iOS',
    src: require('../../assets/logos/technologies/ios.svg').default,
    sections: ['app', 'agency']
  },
  {
    title: 'Vue Native',
    src: require('../../assets/logos/technologies/vue-native.svg').default,
    sections: ['app']
  },
  {
    title: 'Ionic',
    src: require('../../assets/logos/technologies/ionic.svg').default,
    sections: ['app']
  },
  {
    title: 'Cordova',
    src: require('../../assets/logos/technologies/cordova.svg').default,
    sections: ['app']
  },
  {
    title: 'Angular',
    src: require('../../assets/logos/technologies/angular.svg').default,
    sections: ['app']
  },
  {
    title: 'React',
    src: require('../../assets/logos/technologies/react.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'Vue',
    src: require('../../assets/logos/technologies/vue.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'Laravel',
    src: require('../../assets/logos/technologies/laravel.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'JavaScript',
    src: require('../../assets/logos/technologies/javascript.svg').default,
    sections: ['web', 'app', 'agency']
  },
  {
    title: 'Go',
    src: require('../../assets/logos/technologies/go.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'Docker',
    src: require('../../assets/logos/technologies/docker.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'AWS',
    src: require('../../assets/logos/technologies/aws.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'Kubernetes',
    src: require('../../assets/logos/technologies/kubernetes.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'Firebase',
    src: require('../../assets/logos/technologies/firebase.svg').default,
    sections: ['web', 'app', 'agency']
  },
  {
    title: 'JEST',
    src: require('../../assets/logos/technologies/jest.svg').default,
    sections: ['web', 'app']
  },
  {
    title: 'JSON:API',
    src: require('../../assets/logos/technologies/jsonapi.svg').default,
    sections: ['web', 'app']
  },
  {
    title: 'MongoDB',
    src: require('../../assets/logos/technologies/mongodb.svg').default,
    sections: ['web']
  },
  {
    title: 'MySQL',
    src: require('../../assets/logos/technologies/mysql.svg').default,
    sections: ['web']
  },
  {
    title: 'PostgreSQL',
    src: require('../../assets/logos/technologies/postgresql.svg').default,
    sections: ['web']
  },
  {
    title: 'Nodejs',
    src: require('../../assets/logos/technologies/nodejs.svg').default,
    sections: ['web', 'app']
  },
  {
    title: 'nuxt.js',
    src: require('../../assets/logos/technologies/nuxt.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'PHP',
    src: require('../../assets/logos/technologies/php.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'Redux',
    src: require('../../assets/logos/technologies/redux.svg').default,
    sections: ['web', 'app']
  },
  {
    title: 'Rest',
    src: require('../../assets/logos/technologies/rest.svg').default,
    sections: ['web', 'app']
  },
  {
    title: 'TypeScript',
    src: require('../../assets/logos/technologies/typescript.svg').default,
    sections: ['web', 'app']
  },
  {
    title: 'Wordpress',
    src: require('../../assets/logos/technologies/wordpress.svg').default,
    sections: ['web', 'agency']
  },
  {
    title: 'Netlify',
    src: require('../../assets/logos/technologies/netlify.svg').default,
    sections: ['web']
  },
  {
    title: 'Atlassian',
    src: require('../../assets/logos/technologies/atlassian.svg').default,
    sections: ['web', 'app', 'agency']
  },
  {
    title: 'Trello',
    src: require('../../assets/logos/technologies/trello.svg').default,
    sections: ['web', 'app', 'agency']
  },
  {
    title: 'Facebook',
    src: require('../../assets/logos/technologies/facebook.svg').default,
    sections: ['marketing']
  },
  {
    title: 'Instagram',
    src: require('../../assets/logos/technologies/instagram.svg').default,
    sections: ['marketing']
  },
  {
    title: 'YouTube',
    src: require('../../assets/logos/technologies/youtube.svg').default,
    sections: ['marketing']
  },
  {
    title: 'Xing',
    src: require('../../assets/logos/technologies/xing.svg').default,
    sections: ['marketing']
  },
  {
    title: 'LinkedIn',
    src: require('../../assets/logos/technologies/linkedin.svg').default,
    sections: ['marketing']
  },
  {
    title: 'Google Ads',
    src: require('../../assets/logos/technologies/goads.svg').default,
    sections: ['marketing']
  },
  {
    title: 'Google Analytics',
    src: require('../../assets/logos/technologies/google-analytics.svg')
      .default,
    sections: ['marketing']
  },
  {
    title: 'HubSpot',
    src: require('../../assets/logos/technologies/hubspot.svg').default,
    sections: ['marketing']
  },
  {
    title: 'Hotjar',
    src: require('../../assets/logos/technologies/hotjar.svg').default,
    sections: ['marketing']
  },
  {
    title: 'Zapier',
    src: require('../../assets/logos/technologies/zapier.svg').default,
    sections: ['marketing']
  },
  {
    title: 'Google AdSense',
    src: require('../../assets/logos/technologies/goad.svg').default,
    sections: ['marketing']
  },
  {
    title: 'CleverReach',
    src: require('../../assets/logos/technologies/cleverreach.svg').default,
    sections: ['marketing']
  },
  {
    title: 'Adobe Photoshop',
    src: require('../../assets/logos/technologies/adobe-photoshop.svg').default,
    sections: ['design']
  },
  {
    title: 'Adobe Illustrator',
    src: require('../../assets/logos/technologies/adobe-illustrator.svg')
      .default,
    sections: ['design']
  },
  {
    title: 'Adobe InDesign',
    src: require('../../assets/logos/technologies/adobe-indesign.svg').default,
    sections: ['design']
  },
  {
    title: 'Adobe Xd',
    src: require('../../assets/logos/technologies/adobe-xd.svg').default,
    sections: ['design']
  },
  {
    title: 'Sketch',
    src: require('../../assets/logos/technologies/sketch.svg').default,
    sections: ['design']
  },
  {
    title: 'Figma',
    src: require('../../assets/logos/technologies/figma.svg').default,
    sections: ['design']
  },
  {
    title: 'Balsamiq',
    src: require('../../assets/logos/technologies/balsamiq.svg').default,
    sections: ['design']
  },
  {
    title: 'Storybook',
    src: require('../../assets/logos/technologies/storybook.svg').default,
    sections: ['design']
  },
  {
    title: 'Zeroheight',
    src: require('../../assets/logos/technologies/zeroheight.svg').default,
    sections: ['design']
  },
  {
    title: 'Lookback',
    src: require('../../assets/logos/technologies/lookback.svg').default,
    sections: ['design']
  },
  {
    title: 'Whimsical',
    src: require('../../assets/logos/technologies/whimsical.svg').default,
    sections: ['design']
  },
  {
    title: 'Overflow',
    src: require('../../assets/logos/technologies/overflow.svg').default,
    sections: ['design']
  },
  {
    title: 'Slack',
    src: require('../../assets/logos/technologies/slack.svg').default,
    sections: ['app', 'agency']
  }
]

const Technologien = ({
  dark = true,
  technologie = 'all'
}: {
  dark?: boolean
  technologie?: 'app' | 'web' | 'design' | 'marketing' | 'agency' | 'all'
}) => {
  return (
    <Section dark={dark}>
      <div className="container">
        <Title
          title="Verwendete <span>Technologien & Tools</span>"
          titleSize={0}
        />
        <LogoContainer
          items={
            technologie === 'all'
              ? availableItems
              : availableItems.filter((i) => i.sections.includes(technologie))
          }
        />
      </div>
    </Section>
  )
}

export default Technologien
